import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircle2Icon, CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const painPoints = [{
  title: 'Querés emprender pero no sabés por dónde empezar',
  desc: 'y cada vez que buscas información terminás <strong class="text-pain-red font-bold">más confundida que antes.</strong>'
}, {
  title: 'Ya intentaste aprender en YouTube',
  desc: 'y los lotes te salieron mal porque los videos <strong class="text-pain-red font-bold">saltan los pasos clave.</strong>'
}, {
  title: 'Creés que emprender es muy caro',
  desc: 'y gastaste plata en <strong class="text-pain-red font-bold">materiales equivocados sin resultados.</strong>'
}, {
  title: 'Hacés productos lindos pero no sabés cómo venderlos',
  desc: 'y terminás <strong class="text-pain-red font-bold">regalándolos o acumulando stock.</strong>'
}, {
  title: 'Probaste cursos caros que no cumplieron lo prometido',
  desc: 'y perdiste confianza en <strong class="text-pain-red font-bold">volver a invertir.</strong>'
}];
export function PainPointsSection() {
  return <section className="py-12 px-4 bg-white" data-id="element-172">
      <div className="max-w-3xl mx-auto" data-id="element-173">
        <div className="text-center mb-8" data-id="element-174">
          <h2 className="text-3xl md:text-4xl font-bold mb-3" data-id="element-175">
            ¿Esto es para vos?
          </h2>
          <p className="text-lg text-brand-brown/70" data-id="element-176">
            Este sistema es para vos si…
            <br data-id="element-177" />
            Reconocé tu situación en al menos uno de estos puntos:
          </p>
        </div>

        <div className="space-y-3 mb-8" data-id="element-178">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex items-start gap-4 bg-red-50/50 p-4 rounded-xl border border-red-100" data-id="element-179">
              <XCircleIcon className="w-6 h-6 text-pain-red shrink-0 mt-0.5" data-id="element-180" />
              <div data-id="element-181">
                <h3 className="font-bold text-brand-brown text-lg" data-id="element-182">
                  {point.title}
                </h3>
                <p className="text-brand-brown/70 mt-0.5 text-[15px]" dangerouslySetInnerHTML={{
              __html: point.desc
            }} data-id="element-183" />
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex items-start gap-4 bg-green-50 p-5 md:p-6 rounded-2xl border-2 border-solution-green/30 shadow-lg" data-id="element-184">
          <CheckCircle2Icon className="w-7 h-7 text-solution-green shrink-0 mt-0.5" data-id="element-185" />
          <p className="text-base md:text-lg font-medium text-brand-dark-green leading-relaxed" data-id="element-186">
            Si te identificaste con alguno de estos puntos, el{' '}
            <strong className="font-bold" data-id="element-187">Mega Pack Jabones Artesanales</strong>{' '}
            fue diseñado exactamente para vos.
          </p>
        </motion.div>

        <div className="mt-10 text-center max-w-2xl mx-auto" data-id="element-188">
          <p className="text-base md:text-lg text-brand-brown/80 leading-relaxed mb-8" data-id="element-189">
            Si querés crear jabones artesanales de forma rápida y sin
            desperdiciar dinero en materiales equivocados o cursos que no
            explican nada, esta es la herramienta definitiva.
          </p>

          <CTAButton className="w-full md:w-[80%] text-xl py-4 shadow-[0_10px_30px_rgba(45,90,61,0.4)] mb-4" data-id="element-190">
            QUIERO EMPEZAR AHORA →
          </CTAButton>

          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-sm font-bold text-brand-brown/60" data-id="element-191">
            <span className="flex items-center justify-center gap-1.5" data-id="element-192">
              <CheckIcon className="w-4 h-4 text-brand-green stroke-[3]" data-id="element-193" /> Pago
              único
            </span>
            <span className="flex items-center justify-center gap-1.5" data-id="element-194">
              <CheckIcon className="w-4 h-4 text-brand-green stroke-[3]" data-id="element-195" />{' '}
              Acceso inmediato
            </span>
            <span className="flex items-center justify-center gap-1.5" data-id="element-196">
              <CheckIcon className="w-4 h-4 text-brand-green stroke-[3]" data-id="element-197" />{' '}
              Garantía 30 días
            </span>
          </div>
        </div>
      </div>
    </section>;
}